export const EMAIL_BOX_FIELD = {
  id: "email-box-1",
  type: "EmailBox",
  label: "Email Addresses to Share",
  order: 2,
  propertyName: "share-by-email",
  value: [],
  readableValue: [],
  required: false,
  visible: true,
  valid: false,
  readOnly: false, //we need here a true as default, but is set as false to test it now
};

export const EMAIL_BOX_FIELD_CONTROLS = {
  id: "email-box-1",
  defaultEmails: [],
};
